/*
 * Contact form -> WarehouseFever Render service (POST /sendContactEmail).
 * Same payload as the previous theme so the service needs no changes.
 */
(() => {
  class ContactForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.error = this.querySelector('[data-contact-error]');
      this.form?.addEventListener('submit', (e) => this.submit(e));
    }

    value(id) {
      return this.querySelector(`#${id}`)?.value.trim() || '';
    }

    async submit(e) {
      e.preventDefault();
      if (this.busy) return;
      if (!this.form.reportValidity()) return;
      const button = this.form.querySelector('[type="submit"]');
      this.busy = true;
      button.disabled = true;
      this.error.hidden = true;
      const payload = {
        name: this.value('ContactForm-name'),
        email: this.value('ContactForm-email'),
        companyName: this.value('ContactForm-companyName'),
        address: this.value('ContactForm-address'),
        phoneNumber: this.value('ContactForm-phone'),
        comment: this.value('ContactForm-body'),
      };
      try {
        const api = (this.dataset.api || '').replace(/\/+$/, '');
        const res = await fetch(`${api}/sendContactEmail`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        this.form.reset();
        this.querySelector('[data-contact-success]').hidden = false;
        this.querySelector('[data-contact-success]').scrollIntoView({ block: 'nearest' });
      } catch {
        this.error.textContent = this.dataset.msgError;
        this.error.hidden = false;
      } finally {
        this.busy = false;
        button.disabled = false;
      }
    }
  }
  customElements.define('contact-form', ContactForm);
})();
